export default __webpack_public_path__ + "static/media/devguide13.0d8abad2.md";